import script from "./header-toolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./header-toolbar.vue?vue&type=script&setup=true&lang=js"

import "./header-toolbar.vue?vue&type=style&index=0&id=f9225f08&lang=scss"

const __exports__ = script;

export default __exports__